import { cl } from '../common/functions';

let loader = () => {
  // [LOADER] remove
  let loader = document.getElementById('map-container__loader');
  if (loader !== null) {
    setTimeout(() => {
      loader.style.opacity = '0';
      setTimeout(() => {
        loader.style.display = 'none';
      }, 500);
    }, 1000);
  }

  // [MARKER] remove animation
  setTimeout(() => {
    let leafletMarkerPane = document.querySelector('.leaflet-marker-pane');
    if (leafletMarkerPane !== null) {
      leafletMarkerPane.classList.add('no-animation');
    }
  }, 2500);
};

export { loader };
